import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { BALANCE_LOGS_KEY, LOGS_KEY, MINDALAY_ADMIN, PAYMENT_LOGS_KEY } from "../../../../Constants/urlKeys";
import TranslationService from "../../../../Services/translationService";
import { showOrHideGeneralDashboardLeftMenu } from '../../../../Store/Actions/generalLeftMenu';

const LogSubMenu = (props) => {
  const dispatch = useDispatch();
  const language = useSelector(state => state.language.language);
  const translations = useSelector(state => state.translation.translations);
  const [translationService, setTranslationService] = useState(null);

  useEffect(() => {
    setTranslationService(new TranslationService(translations));
  }, [translations]);

  const showOrHideLeftMenu = (bool) => {
    dispatch(showOrHideGeneralDashboardLeftMenu(bool));
  }

  return translationService ? <aside className="side-left-submenu">
    <div className="side-left-submenu-container">
      <ul className="side-left-submenu-list">
        <li className="side-left-submenu-item">
          <NavLink
            to={`/${language}/${MINDALAY_ADMIN}/${LOGS_KEY}`}
            className={props.location.pathname.includes(`/${LOGS_KEY}`) && !props.location.pathname.includes(`/${PAYMENT_LOGS_KEY}`) ? "active-text" : ""}
            onClick={() => showOrHideLeftMenu(false)}
          >
            {translationService.translate("TR_LOGS")}
          </NavLink>
        </li>
        <li className="side-left-submenu-item">
          <NavLink
            to={`/${language}/${MINDALAY_ADMIN}/${PAYMENT_LOGS_KEY}`}
            className={props.location.pathname.includes(`/${PAYMENT_LOGS_KEY}`) ? "active-text" : ""}
            onClick={() => showOrHideLeftMenu(false)}
          >
            {/* {translationService.translate("TR_PAYMENT_LOGS")} */}
            Local payment
          </NavLink>
        </li>
        <li className="side-left-submenu-item">
          <NavLink
            to={`/${language}/${MINDALAY_ADMIN}/${BALANCE_LOGS_KEY}`}
            className={props.location.pathname.includes(`/${BALANCE_LOGS_KEY}`) ? "active-text" : ""}
            onClick={() => showOrHideLeftMenu(false)}
          >
            {/* {translationService.translate("TR_PAYMENT_LOGS")} */}
            Balance logs
          </NavLink>
        </li>

      </ul>
    </div>
  </aside> : null;
}

export default withRouter(LogSubMenu);